export default {"src":"/_next/static/media/bytes-logo.840fb1a5.svg","height":44,"width":101};